import * as React from "react";
import { DataGrid } from "@mui/x-data-grid"; // Import DataGrid
import Paper from "@mui/material/Paper";

export default function DataGridTable({ columns, rows, onRowClick }) {
  return (
    <Paper sx={{ width: "100%", overflow: "hidden", boxShadow:'none' }}>
      <div style={{ width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5, 10, 25]}
          pagination
          autoHeight
          onRowClick={(params) => onRowClick(params.row)}
          sx={{
            fontFamily: "Nunito Sans, sans-serif",
            fontSize: "14px",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#ebebeb",
              color: "#000",
              fontWeight: "bold",
              fontSize: "14px",
              padding: "6px",
              fontFamily: "Nunito Sans, sans-serif",
            },
            "& .MuiDataGrid-cell": {
              padding: "6px",
              fontFamily: "Nunito Sans, sans-serif",
              fontSize: "14px",
            },
            "& .MuiDataGrid-row:hover": {
              cursor: "pointer",
              backgroundColor: "#f5f5f5",
            },
          }}
        />
      </div>
    </Paper>
  );
}
